import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ModalB from "react-bootstrap/Modal";
import { FaSearch, FaSpinner, FaTimes } from "react-icons/fa";
import api from "../../services/axios";
import { marcarHorariosConteudo } from "../../services/conteudoSlots";
import LinhaModalReunioes from "./linhaModalReunioes";
import "./modalReunioes.css";

const LIMITE_REUNIOES_CONVIDADO = 6;

function normalizarHora(valor) {
  if (!valor) return "";
  const texto = String(valor);
  return texto.length >= 5 ? texto.substring(0, 5) : texto;
}

function extrairDataHora(dt) {
  const texto = String(dt || "");
  return {
    data: texto.substring(0, 10),
    hora: texto.length >= 16 ? texto.substring(11, 16) : "",
  };
}

function contarOcupacaoPatrocinador(patrocinador, dataSelecionada, horariosDia) {
  const contagem = {};
  horariosDia.forEach((h) => {
    contagem[h] = 0;
  });

  (patrocinador?.usuarios || []).forEach((u) => {
    (u.agendaParticipante || []).forEach((ap) => {
      const agenda = ap.agenda;
      if (!agenda) return;
      if (agenda.tipo !== "reuniao_negocio") return;
      if (agenda.nome === "Reunião de almoço/jantar") return;

      const dt = agenda.dt_hora_inicio || agenda.dtHoraInicio;
      const { data, hora } = extrairDataHora(dt);
      if (data !== dataSelecionada) return;
      if (contagem[hora] === undefined) return;
      contagem[hora] += 1;
    });
  });

  return contagem;
}

function enriquecerParticipante(participante, ctx) {
  const {
    dataSelecionada,
    horariosDia,
    ocupacaoPatrocinador,
    cota,
    slots,
  } = ctx;

  const indisponivel = new Set();
  const selectIndisponivel = new Set();
  const destinos = [indisponivel, selectIndisponivel];

  (participante.agendaParticipante || []).forEach((a) => {
    const agenda = a.agenda;
    if (!agenda) return;
    const dt = agenda.dt_hora_inicio || agenda.dtHoraInicio;
    const { data, hora } = extrairDataHora(dt);
    if (!data || data !== dataSelecionada || !hora) return;

    if (
      agenda.tipo === "conteudo_patrocinado" ||
      agenda.tipo === "conteudo_editorial"
    ) {
      marcarHorariosConteudo({
        idAgendaConteudo: agenda.id,
        horaInicio: hora,
        slots,
        dataSelecionada,
        horariosDia,
        destinos,
      });
      return;
    }

    indisponivel.add(hora);
    selectIndisponivel.add(hora);
  });

  ;[participante.conteudo1, participante.conteudo2].forEach((idConteudo) => {
    if (!idConteudo) return;
    marcarHorariosConteudo({
      idAgendaConteudo: idConteudo,
      horaInicio: "",
      slots,
      dataSelecionada,
      horariosDia,
      destinos,
    });
  });

  if (cota) {
    horariosDia.forEach((h) => {
      if ((ocupacaoPatrocinador[h] || 0) >= cota) {
        selectIndisponivel.add(h);
      }
    });
  }

  const contadorReuniao = (participante.agendaParticipante || []).filter(
    (apc) =>
      apc.agenda?.tipo === "reuniao_negocio" &&
      apc.agenda?.nome !== "Reunião de almoço/jantar"
  ).length;

  const lotado = contadorReuniao >= LIMITE_REUNIOES_CONVIDADO;
  if (lotado) {
    horariosDia.forEach((h) => {
      indisponivel.add(h);
      selectIndisponivel.add(h);
    });
  }

  const horariosDisponiveis = horariosDia.filter((h) => !indisponivel.has(h));
  const horariosSelecionaveis = horariosDia.filter(
    (h) => !selectIndisponivel.has(h)
  );

  return {
    ...participante,
    horariosDisponiveis,
    horariosSelecionaveis,
    disponibilidade: horariosDisponiveis.join(" "),
    selectdisponibilidade: horariosSelecionaveis.join(" "),
    mostrarbotao: !lotado,
  };
}

const ModalReunioes = (props) => {
  const [empresa, setEmpresa] = useState("");
  const [cargo, setCargo] = useState("");
  const [disponibilidade, setDisponibilidade] = useState("");
  const [pesquisaNome, setPesquisaNome] = useState("");
  const [participantes, setParticipantes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [diasEvento, setDiasEvento] = useState([]);
  const [slots, setSlots] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState("");
  const [patrocinadorInfo, setPatrocinadorInfo] = useState(null);
  const [quantidadeAgenda, setQuantidadeAgenda] = useState(0);
  const [loadingMeta, setLoadingMeta] = useState(false);
  const [loadingLista, setLoadingLista] = useState(false);
  const [error, setError] = useState(null);

  const carregaUsuarioRef = useRef(props.carrega_usuario);
  const cotaRef = useRef(props.cota);
  const patrocinadorInfoRef = useRef(patrocinadorInfo);

  useEffect(() => {
    carregaUsuarioRef.current = props.carrega_usuario;
  }, [props.carrega_usuario]);

  useEffect(() => {
    cotaRef.current = props.cota;
  }, [props.cota]);

  useEffect(() => {
    patrocinadorInfoRef.current = patrocinadorInfo;
  }, [patrocinadorInfo]);

  const handleModal = () => props.toggleModal?.();

  const diasComSlots = useMemo(() => {
    const datas = [...new Set(slots.map((s) => s.data).filter(Boolean))].sort();
    return datas.map((data) => {
      const [, mes, dia] = String(data).split("-");
      const fromEvento = diasEvento.find((d) => d.data === data);
      return {
        data,
        dia: fromEvento?.dia || dia,
        label: fromEvento?.label || `${dia}/${mes}`,
      };
    });
  }, [slots, diasEvento]);

  const diaSelecionado = useMemo(() => {
    const encontrado = diasComSlots.find((d) => d.data === dataSelecionada);
    return encontrado?.dia || props.dia || "";
  }, [diasComSlots, dataSelecionada, props.dia]);

  const slotsDoDia = useMemo(() => {
    if (!dataSelecionada) return [];
    return slots
      .filter((s) => s.data === dataSelecionada)
      .slice()
      .sort((a, b) =>
        String(a.horario_inicio || "").localeCompare(
          String(b.horario_inicio || "")
        )
      );
  }, [slots, dataSelecionada]);

  const horariosDia = useMemo(
    () => slotsDoDia.map((s) => normalizarHora(s.horario_inicio)).filter(Boolean),
    [slotsDoDia]
  );

  const ocupacaoPatrocinador = useMemo(
    () =>
      contarOcupacaoPatrocinador(
        patrocinadorInfo,
        dataSelecionada,
        horariosDia
      ),
    [patrocinadorInfo, dataSelecionada, horariosDia]
  );

  const showIncluir = useMemo(() => {
    if (props.tipoAgenda === "m_m") return true;
    if (!props.cota_quantidade) return true;
    return quantidadeAgenda < props.cota_quantidade;
  }, [quantidadeAgenda, props.cota_quantidade, props.tipoAgenda]);

  const carregarMeta = useCallback(async () => {
    setLoadingMeta(true);
    setError(null);

    try {
      const [respDias, respSlots, respEmpresas, respCargos] = await Promise.all([
        api.get("/agenda-dias-evento"),
        api.get("/slots"),
        api.get("/usuarios-empresas"),
        api.get("/usuarios-cargos"),
      ]);

      const dias = respDias.data?.dados?.dias || [];
      const listaSlots = respSlots.data?.dados || [];
      setDiasEvento(dias);
      setSlots(listaSlots);
      setEmpresas(respEmpresas.data?.dados || []);
      setCargos(respCargos.data?.dados || []);

      const datasSlots = [
        ...new Set(listaSlots.map((s) => s.data).filter(Boolean)),
      ].sort();

      let dataInicial = "";
      if (props.dia) {
        const diaNorm = String(props.dia).padStart(2, "0");
        const match =
          dias.find((d) => d.dia === diaNorm) ||
          datasSlots
            .map((data) => ({ data, dia: data.substring(8, 10) }))
            .find((d) => d.dia === diaNorm);
        dataInicial = match?.data || "";
      }
      if (!dataInicial) {
        dataInicial = datasSlots[0] || dias[0]?.data || "";
      }
      setDataSelecionada(dataInicial);

      if (props.id_info) {
        const respPatrocinador = await api.post(
          "/patrocinador-verifica-disponibilidade",
          { id_info: props.id_info }
        );
        const patro = respPatrocinador.data?.patrocinador || null;
        setPatrocinadorInfo(patro);
        patrocinadorInfoRef.current = patro;
        setQuantidadeAgenda(respPatrocinador.data?.quantidadeAgenda || 0);
      } else {
        setPatrocinadorInfo(null);
        patrocinadorInfoRef.current = null;
        setQuantidadeAgenda(0);
      }
    } catch (err) {
      console.error("Erro ao carregar metadados do modal:", err);
      setError("Erro ao carregar dias, slots e filtros.");
    } finally {
      setLoadingMeta(false);
    }
  }, [props.dia, props.id_info]);

  const carregarParticipantes = useCallback(async () => {
    if (!dataSelecionada || horariosDia.length === 0) {
      setParticipantes([]);
      return;
    }

    setLoadingLista(true);
    setError(null);

    try {
      if (carregaUsuarioRef.current) {
        await carregaUsuarioRef.current();
      }

      const respUsuarios = await api.post(`/usuarios-apenas-reunioes`, {
        tipo: ["convidado"],
      });

      if (respUsuarios.status === 200) {
        const ocupacao = contarOcupacaoPatrocinador(
          patrocinadorInfoRef.current,
          dataSelecionada,
          horariosDia
        );
        const enriquecidos = (respUsuarios.data.dados || []).map((p) =>
          enriquecerParticipante(p, {
            dataSelecionada,
            horariosDia,
            ocupacaoPatrocinador: ocupacao,
            cota: cotaRef.current,
            slots,
          })
        );
        setParticipantes(enriquecidos);
      }
    } catch (err) {
      console.error("Erro ao carregar participantes:", err);
      setError("Erro ao carregar convidados disponíveis.");
      setParticipantes([]);
    } finally {
      setLoadingLista(false);
    }
  }, [dataSelecionada, horariosDia, slots]);

  const recarregarTudo = useCallback(async () => {
    if (props.id_info) {
      try {
        const respPatrocinador = await api.post(
          "/patrocinador-verifica-disponibilidade",
          { id_info: props.id_info }
        );
        setPatrocinadorInfo(respPatrocinador.data?.patrocinador || null);
        setQuantidadeAgenda(respPatrocinador.data?.quantidadeAgenda || 0);
        patrocinadorInfoRef.current =
          respPatrocinador.data?.patrocinador || null;
      } catch (err) {
        console.error("Erro ao atualizar disponibilidade:", err);
      }
    }
    await carregarParticipantes();
  }, [props.id_info, carregarParticipantes]);

  useEffect(() => {
    if (!props.show) return;
    setPesquisaNome("");
    setEmpresa("");
    setCargo("");
    setDisponibilidade("");
    carregarMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    if (!props.show || !dataSelecionada || loadingMeta) return;
    setDisponibilidade("");
    carregarParticipantes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, dataSelecionada, loadingMeta, horariosDia.join("|")]);

  const listaFiltrada = useMemo(() => {
    const idAtual = parseInt(props.id, 10);
    const idsMarcados = props.ids_convidados || [];
    const termoNome = pesquisaNome.trim().toLowerCase();
    const termoEmpresa = empresa.trim().toLowerCase();
    const termoCargo = cargo.trim().toLowerCase();

    return participantes.filter((p) => {
      if (p.id === idAtual) return false;
      if (idsMarcados.includes(p.id)) return false;

      if (termoNome && !(p.nome || "").toLowerCase().includes(termoNome)) {
        return false;
      }
      if (
        termoEmpresa &&
        !(p.empresa || "").toLowerCase().includes(termoEmpresa)
      ) {
        return false;
      }
      if (termoCargo && !(p.cargo || "").toLowerCase().includes(termoCargo)) {
        return false;
      }
      if (disponibilidade) {
        const selecionaveis = p.horariosSelecionaveis || [];
        if (!selecionaveis.includes(disponibilidade)) return false;
      }
      return true;
    });
  }, [
    participantes,
    props.id,
    props.ids_convidados,
    pesquisaNome,
    empresa,
    cargo,
    disponibilidade,
  ]);

  const labelDiaAtivo = useMemo(() => {
    const d = diasComSlots.find((item) => item.data === dataSelecionada);
    return d?.label || "—";
  }, [diasComSlots, dataSelecionada]);

  const loading = loadingMeta || loadingLista;

  return (
    <ModalB
      show={props.show}
      onHide={handleModal}
      centered
      size="xl"
      className="modal-reunioes-apl"
      backdrop={loading ? "static" : true}
    >
      <ModalB.Header closeButton={!loading}>
        <div>
          <ModalB.Title className="titulo-modal">
            {props.titulo ||
              (props.tipoAgenda === "m_m"
                ? "Nova reunião Match & Meet"
                : "Nova reunião de trabalho")}
          </ModalB.Title>
          <p className="mr-header-sub">
            {props.tipoAgenda === "m_m"
              ? "Selecione o dia, o horário e o convidado para agendar uma reunião Match & Meet."
              : "Filtre por dia e horário com base nos slots cadastrados e confirme a reunião com o convidado disponível."}
          </p>
        </div>
      </ModalB.Header>

      <ModalB.Body>
        {error ? (
          <div className="mr-alert" role="alert">
            {error}
          </div>
        ) : null}

        {!showIncluir ? (
          <div className="mr-alert mr-alert--warn" role="status">
            A cota de reuniões deste patrocinador foi atingida (
            {quantidadeAgenda}/{props.cota_quantidade}).
          </div>
        ) : null}

        <nav className="mr-day-tabs" aria-label="Dias com slots">
          {loadingMeta && diasComSlots.length === 0 ? (
            <span className="mr-header-sub">Carregando dias…</span>
          ) : diasComSlots.length === 0 ? (
            <span className="mr-header-sub">
              Nenhum slot cadastrado para o evento.
            </span>
          ) : (
            diasComSlots.map((item) => {
              const qtd = slots.filter((s) => s.data === item.data).length;
              return (
                <button
                  key={item.data}
                  type="button"
                  className={`mr-day-tab${
                    dataSelecionada === item.data ? " is-active" : ""
                  }`}
                  onClick={() => setDataSelecionada(item.data)}
                  disabled={loadingMeta}
                >
                  {item.label}
                  <span className="mr-day-tab-count">{qtd}</span>
                </button>
              );
            })
          )}
        </nav>

        <div className="mr-content">
          <aside className="mr-filters" aria-label="Filtros">
            <div className="mr-field">
              <label htmlFor="mr_input_nome">Nome</label>
              <div className="mr-search">
                <span className="mr-search-icon" aria-hidden>
                  <FaSearch size={13} />
                </span>
                <input
                  id="mr_input_nome"
                  type="search"
                  className="mr-input"
                  placeholder="Buscar por nome…"
                  value={pesquisaNome}
                  onChange={(e) => setPesquisaNome(e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <div className="mr-field">
              <label htmlFor="mr_input_empresa">Empresa</label>
              <select
                id="mr_input_empresa"
                className="mr-select"
                value={empresa}
                onChange={(e) => setEmpresa(e.target.value)}
                disabled={loading}
              >
                <option value="">Todas</option>
                {empresas.map((e, i) => (
                  <option key={`${e.empresa}-${i}`} value={e.empresa}>
                    {e.empresa}
                  </option>
                ))}
              </select>
            </div>

            <div className="mr-field">
              <label htmlFor="mr_input_cargo">Cargo</label>
              <select
                id="mr_input_cargo"
                className="mr-select"
                value={cargo}
                onChange={(e) => setCargo(e.target.value)}
                disabled={loading}
              >
                <option value="">Todos</option>
                {cargos.map((c, i) => (
                  <option key={`${c.cargo}-${i}`} value={c.cargo}>
                    {c.cargo}
                  </option>
                ))}
              </select>
            </div>

            <div className="mr-field">
              <label htmlFor="mr_input_disponibilidade">Disponibilidade</label>
              <select
                id="mr_input_disponibilidade"
                className="mr-select"
                value={disponibilidade}
                onChange={(e) => setDisponibilidade(e.target.value)}
                disabled={loading || slotsDoDia.length === 0}
              >
                <option value="">Qualquer horário</option>
                {slotsDoDia.map((slot) => {
                  const hora = normalizarHora(slot.horario_inicio);
                  const ocupados = ocupacaoPatrocinador[hora] || 0;
                  const cota = props.cota || 0;
                  const lotado = cota > 0 && ocupados >= cota;
                  return (
                    <option key={slot.id} value={hora}>
                      {labelDiaAtivo} · {hora}
                      {slot.descricao ? ` — ${slot.descricao}` : ""}
                      {cota > 0 ? ` (${ocupados}/${cota})` : ""}
                      {lotado ? " · lotado" : ""}
                    </option>
                  );
                })}
              </select>
            </div>
          </aside>

          <div className="mr-list-panel">
            <div className="mr-meta">
              <span>
                Exibindo <strong>{listaFiltrada.length}</strong>{" "}
                {listaFiltrada.length === 1 ? "convidado" : "convidados"}
                {dataSelecionada ? (
                  <>
                    {" "}
                    em <strong>{labelDiaAtivo}</strong>
                  </>
                ) : null}
              </span>
              <span>
                {horariosDia.length}{" "}
                {horariosDia.length === 1 ? "slot no dia" : "slots no dia"}
              </span>
            </div>

            <section className="mr-list-card" aria-label="Lista de convidados">
              <div className="mr-list-head">
                <div>Nome</div>
                <div>Empresa</div>
                <div>Cargo</div>
                <div>Disponibilidade</div>
              </div>

              <div className="mr-list-body">
                {loading ? (
                  <div className="mr-loading">
                    <FaSpinner className="fa-spin" size={26} aria-hidden />
                    <span>
                      {loadingMeta
                        ? "Carregando dias e slots…"
                        : "Carregando convidados…"}
                    </span>
                  </div>
                ) : listaFiltrada.length === 0 ? (
                  <div className="mr-empty">
                    <p className="mr-empty-title">Nenhum convidado encontrado</p>
                    <p style={{ margin: 0 }}>
                      {horariosDia.length === 0
                        ? "Não há slots cadastrados para este dia."
                        : "Ajuste os filtros ou selecione outro dia."}
                    </p>
                  </div>
                ) : (
                  listaFiltrada.map((p) => (
                    <LinhaModalReunioes
                      key={p.id}
                      participante={p}
                      id={props.id}
                      data={dataSelecionada}
                      dia={diaSelecionado}
                      carregarParticipantes={recarregarTudo}
                      mostrarIncluir={showIncluir}
                      jaMarcado={(props.ids_convidados || []).includes(p.id)}
                      setLoading={setLoadingLista}
                      slotsDoDia={slotsDoDia}
                      tipoAgenda={props.tipoAgenda || "reuniao_negocio"}
                      idPatrocinador={props.id_info}
                    />
                  ))
                )}
              </div>
            </section>
          </div>
        </div>
      </ModalB.Body>

      <ModalB.Footer>
        <button
          type="button"
          className="mr-btn mr-btn--ghost"
          onClick={handleModal}
          disabled={loadingLista}
        >
          <FaTimes size={13} aria-hidden />
          Fechar
        </button>
      </ModalB.Footer>
    </ModalB>
  );
};

export default ModalReunioes;
